import React from 'react';

import PropTypes from 'prop-types';

import { localize } from 'wanderu-i18n';

import styles from './ImageItem.scss';

const propTypes = {
    src: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    imageClassName: PropTypes.string,
};

const defaultProps = {
    imageClassName: '',
};

function ImageItem(props) {
    const {
        t,
        i18nNumber,
        src,
        title,
        description,
        imageClassName,
    } = props;

    const numericalTitle = parseInt(t(title), 10);
    const imageTitle = isNaN(numericalTitle)
        ? t(title)
        : i18nNumber(numericalTitle).format();

    return (
        <div className={`${imageClassName} ${styles.imageItem}`}>
            <img
                alt=""
                src={src}
            />
            <div className={styles.textContainer}>
                <span className={styles.imageTitle}>
                    {imageTitle}
                </span>
                <span className={styles.imageDescription}>
                    {t(description)}
                </span>
            </div>
        </div>
    );
}

ImageItem.propTypes = propTypes;
ImageItem.defaultProps = defaultProps;

export { ImageItem };
export default localize(ImageItem, 'baseApp');
